/* eslint-disable */
/**
 * * 通常来讲，跟其他统计一样， 51la 要把 script 脚本插到页面最前面（保证在其他业务代码之前生效）
 * * 下面简单说下几个使用方法：
 * * --
 * * --
 * * A. 如果只是简单的页面统计，请传 id + ck 即可
 * * B. 如果想统计 `vue/react` 等应用的 hash 路由跳转，须传 hashMode: true
 * * C. 如果想进行事件统计，比如：按钮、跳转链接等，须传 autoTrack: true
 *   * C1. 进行事件统计，须进到 应用后台-事件管理-创建代码事件，然后创建相关事件+代码，并注入到项目中去
 *   * C2. 比如，添加了个充值事件：LA.track('evt_click_recharge')，在相关代码处使用即可
 *   * C3. 如果一个事件比较频繁，也可以在 fzs51la 注入事件属性，然后调用，这样也行
 * @param id
 * @param ck
 * @param autoTrack
 * @param hashMode
 * @param callback
 */
export default function fzs51la ({ id = '', ck = '', autoTrack = false, hashMode = false, callback = () => { } }) {
  if (!id || !ck) {
    return console.error('关键参数缺失!')
  }
  const script = document.createElement('script')
  script.type = 'text/javascript'
  script.async = true
  script.id = 'LA_COLLECT'
  script.charset = 'UTF-8'
  script.src = document.location.protocol + '//' + 'sdk.51.la/js-sdk-pro.min.js'

  if (script.readyState) {
    script.onreadystatechange = () => {
      if (script.readyState === 'loaded' || script.readyState === 'complete') {
        script.onreadystatechange = null
        window.LA.init({ id, ck, autoTrack, hashMode })
        callback && callback()
      }
    }
  }
  else { // 其他浏览器
    script.onload = function () {
      window.LA.init({ id, ck, autoTrack, hashMode })
      callback && callback()
    }
  }

  // 优先 append 到页面最顶部
  const e1 = document.getElementsByTagName("script")[0]
  if (e1 && e1.parentNode) {
    e1.parentNode.insertBefore(script, e1)
  }
  else {
    document.getElementsByTagName('head')[0].appendChild(script)
  }
}

// 以下是举例，大可不必抄下来
function track (name = '') {
  window.LA && window.LA.track && window.LA.track(name)
}
fzs51la.evt_openCard = () => { track('evt_open_card') }
